import axios from 'axios'
import { CRM_API_URL } from '@/constants/api'

function fetchTypes (filialId) {
    return axios.get(`${CRM_API_URL}/orders/payment/types`, { params: { filialId } }).then(response => response.data)
}

function start (orderId) {
    return axios.post(`${CRM_API_URL}/orders/${orderId}/payment/start`).then(response => response.data)
}

function complete (orderId, data) {
    return axios.post(`${CRM_API_URL}/orders/${orderId}/payment/complete`, data).then(response => response.data)
}

function cancel (orderId, data) {
    return axios.post(`${CRM_API_URL}/orders/${orderId}/payment/cancel`, data).then(response => response.data)
}

// Смена типа оплаты (наличные <-> терминал) завершённого заказа доставки
function changeCompleted (orderId, paymentType) {
    return axios.post(`${CRM_API_URL}/orders/${orderId}/change-payment`, { paymentType }).then(response => response.data)
}

function terminalPay (orderId) {
    return axios.post(`${CRM_API_URL}/orders/${orderId}/payment/terminal/pay`).then(response => response.data)
}

function terminalCancel (orderId, data = {}) {
    return axios.post(`${CRM_API_URL}/orders/${orderId}/payment/terminal/cancel`, data).then(response => response.data)
}

function fetchTerminalOperation (orderId, operationId) {
    return axios.get(`${CRM_API_URL}/orders/${orderId}/payment/terminal/${operationId}`).then(response => response.data)
}

// Незавершённая или незаписанная операция терминала по заказу
// ({ operationId, timeoutSeconds, type, status, applied, error, cancelOrder }) или null
function fetchActiveTerminalOperation (orderId) {
    return axios.get(`${CRM_API_URL}/orders/${orderId}/payment/terminal/active`).then(response => response.data.operation)
}

// «Повторить сейчас»: записать результат терминала. Ответ - операция (applied: true) или 422 с причиной
function applyTerminalOperation (orderId, operationId) {
    return axios.post(`${CRM_API_URL}/orders/${orderId}/payment/terminal/${operationId}/apply`).then(response => response.data)
}

export default { fetchTypes, start, complete, cancel, changeCompleted, terminalPay, terminalCancel, fetchTerminalOperation, fetchActiveTerminalOperation, applyTerminalOperation }
